/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetAddressDetailsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeGetAddressDetailsRequest, serializeGetAddressDetailsResponse, type ErrorResponse, type GetAddressDetailsRequest, type GetAddressDetailsResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { PublicRequestBuilderRequestsMetadata, type PublicRequestBuilder } from './public/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/addresses/details
 */
export interface DetailsRequestBuilder extends BaseRequestBuilder<DetailsRequestBuilder> {
    /**
     * The public property
     */
    get public(): PublicRequestBuilder;
    /**
     * Returns detailed address information including postal code for a place ID returned by Lookup Address
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetAddressDetailsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     * @throws {ErrorResponse} error when the service returns a 503 status code
     */
     post(body: GetAddressDetailsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetAddressDetailsResponse | undefined>;
    /**
     * Returns detailed address information including postal code for a place ID returned by Lookup Address
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GetAddressDetailsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DetailsRequestBuilderUriTemplate = "{+baseurl}/api/addresses/details";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DetailsRequestBuilderNavigationMetadata: Record<Exclude<keyof DetailsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    public: {
        requestsMetadata: PublicRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DetailsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DetailsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetAddressDetailsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGetAddressDetailsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
